import React,{Component, type ChangeEvent} from "react";
import {
  TextField,
  Button,
  MenuItem,
  Box,
  Typography
} from "@mui/material";

interface Props {
  onSubmit: (params: any) => void;
}

interface State {
  accountno: string;
  mobileno: string;
  networkid: string;
}

export default class AccountForm extends Component<Props, State> {
  state: State = {
    accountno: "",
    mobileno: "",
    networkid: "",
  };

  handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ [e.target.name]: e.target.value } as any);
  };

  handleSubmit = () => {
    this.props.onSubmit(this.state);
  };

  render() {
    const { accountno, mobileno, networkid } = this.state;

    return (
      <>
        <Typography variant="h6" gutterBottom>
          Momo Registration Request
        </Typography>

        <Box sx={{ display: "grid", gap: 2 }}>
          <TextField
            name="accountno"
            label="Account No"
            value={accountno}
            onChange={this.handleChange}
            required
            fullWidth
          />

          <TextField
            name="mobileno"
            label="Mobile No"
            //select
            value={mobileno}
            onChange={this.handleChange}
            fullWidth
          >
            {/* <MenuItem value="">All</MenuItem>
            <MenuItem value="SAVINGS">Savings</MenuItem>
            <MenuItem value="CURRENT">Current</MenuItem>
            <MenuItem value="LOAN">Loan</MenuItem> */}
          </TextField>

          <TextField
            name="networkid"
            label="Network"
            select
            value={networkid}
            onChange={this.handleChange}
            fullWidth
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="MTN">MTN</MenuItem>
            <MenuItem value="TCL">Telecel</MenuItem>
            <MenuItem value="ATT">AirtelTigo</MenuItem>
          </TextField>

          <Button
            variant="contained"
            sx={{ mt: 2 }}
            disabled={!accountno}
            onClick={this.handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </>
    );
  }
}